module.exports = __webpack_public_path__ + "static/media/search ico@3x.41201966.png";